import CrudModel from 'model-fns';
import Effects from '../../effects';
import xtend from 'xtend';

var crudModel = CrudModel('assetID');

function AssetsModel (api) {
    function model () {
        return crudModel();
    }

    model.effects = Effects(api.assets);
    model.update = xtend(crudModel.update, {
        getMiscAssets: function (state, ev) {
            return xtend(crudModel.update.get(state, ev), {
                hasFetched: true
            });
        }
    });
    return model;
}

export default AssetsModel;
